var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractService from './abstract-service';
import Exception from '@vertical-plus/vue-js-api-platform/dist/model/exception/exception';
export default class AbstractAuthenticatedService extends AbstractService {
    /**
     * Constructor
     */
    constructor(store, authenticationService) {
        super(store);
        this.authenticationService = authenticationService;
    }
    /**
     * Runs a task, refreshing the token as appropriate
     *
     * @param task
     * @returns
     */
    runTask(task) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield task.run();
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            catch (error) {
                switch (error.message) {
                    case Exception.TokenExpired:
                        // Refresh the token
                        yield this.authenticationService.refreshToken();
                        // Re-try the request with the new token
                        task.token = this.token;
                        return task.run();
                    default:
                        throw error;
                }
            }
        });
    }
}
//# sourceMappingURL=abstract-authenticated-service.js.map